module.exports = __webpack_public_path__ + "static/media/img-sobre.332909dc.png";